import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/request'
import apis from '@/apis/index'

Vue.use(Vuex)

const loginUser = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
loginUser.id = loginUser.userId
loginUser.name = loginUser.userName
export default new Vuex.Store({
  state: {
    /** 流程引擎使用 begin */
    nodeMap: new Map(),
    formItemMap: new Map(),
    isEdit: null,
    loginUser: loginUser,
    selectedNode: {},
    selectFormItem: null,
    design:{},
    /** 流程引擎使用 end */
    token: sessionStorage.getItem('token') || '',
    customer: localStorage.getItem('customer') || '',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
    menuList: JSON.parse(sessionStorage.getItem('menuList') || '{}'),
    buttonList: [],
    keepAlive: [],
    projectId: sessionStorage.getItem('projectId') || '',
    projectList: JSON.parse(sessionStorage.getItem('projectList') || '[]'),
    cadVersion: sessionStorage.getItem('cadVersion') || '',
    mainMenuIndex: sessionStorage.getItem('mainMenuIndex') || 0
  },
  mutations: {
    /** 流程引擎使用 begin */
    selectedNode(state, val) {
      state.selectedNode = val
    },
    loadForm(state, val){
      state.design = val
    },
    setIsEdit(state, val){
      state.isEdit = val
    },
    /** 流程引擎使用 end */
    setProjectId (state, projectId) {
      state.projectId = projectId
      sessionStorage.setItem('projectId', projectId)
    },
    setProjectList (state, list) {
      state.projectList = list
      sessionStorage.setItem('projectList', JSON.stringify(list))
    },
    setToken (state, token) {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    setCustomer (state, customer) {
      state.customer = customer
      localStorage.setItem('customer', customer)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      state.loginUser = {
        id: userInfo.userId,
        name: userInfo.userName
      }
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    updateMenuList (state, data) {
      state.menuList = data
    },
    updateButtonList (state, data) {
      state.buttonList = data
    },
    addKeepAlive (state, data) {
      if (!state.keepAlive.includes(data)) {
        state.keepAlive.push(data)
      }
    },
    removeKeepAlive (state, data) {
      const index = state.keepAlive.findIndex(item => item === data)
      state.keepAlive.splice(index, 1)
    },
    setCadVersion (state, data) {
      state.cadVersion = data
      sessionStorage.setItem('cadVersion', data)
    },
    setMainMenuIndex (state, data) {
      state.mainMenuIndex = data
      sessionStorage.setItem('mainMenuIndex', data)
    },
    logout(state) {
      sessionStorage.clear()
      state.token = ''
      state.customer = ''
      state.userInfo = {}
      state.menuList = {}
      state.buttonList = []
      state.keepAlive = []
      state.projectId = ''
      state.projectList = []
      state.cadVersion = ''
      state.mainMenuIndex = 0
    }
  },
  getters: {
    project (state) {
      return state.projectList.find(item => item.projectId === state.projectId) || {}
    },
    mapCenter (state, getters) {
      return [+getters.project.longitude || 118.7587, +getters.project.latitude || 31.9686]
    },
    isCad (state, getters) {
      const project = getters.project
      return project ? (project.cadId ? '1' : '0') : '0'
    },
    topMenuList(state) {
      return (state.menuList.find(item => item.menuCode === 'ZHDPT') || {}).childNode || []
    },
    rightMenuList (state) {
      return (state.menuList.find(item => item.menuCode === 'SYDTKB') || {}).childNode || []
    }
  },
  actions: {
    // 获取菜单
    async getMenu ({ commit }) {
      return await axios.get(apis.system.getMenu).then(res => {
        commit('updateMenuList', res)
        sessionStorage.setItem('menuList', JSON.stringify(res))
        return res
      })
    },
    getProjectList ({ state, commit }) {
      return axios.get(apis.project.selectJgProjectAllByList).then(res => {
        commit('setProjectList', res)
        if (!state.projectId) {
          commit('setProjectId', res[0].projectId)
        }
      })
    }
  },
  modules: {
  }
})
